import React from "react";
import { motion } from "framer-motion";

const Loader = ({ size = "medium", fullScreen = false, message = "" }) => {
  const sizeMap = {
    small: { width: "30px", height: "30px", borderWidth: "3px" },
    medium: { width: "50px", height: "50px", borderWidth: "4px" },
    large: { width: "70px", height: "70px", borderWidth: "5px" },
  };

  const spinnerStyle = {
    width: sizeMap[size]?.width || "50px",
    height: sizeMap[size]?.height || "50px",
    border: `${sizeMap[size]?.borderWidth || "4px"} solid #F8F8F8`,
    borderTopColor: "#D9A321",
    borderRadius: "50%",
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    minHeight: fullScreen ? "100vh" : "200px",
    width: "100%",
  };

  const messageStyle = {
    color: "#5A5A5A",
    fontSize: "0.875rem",
    fontFamily: "'Inter', sans-serif",
  };

  return (
    <div style={containerStyle} className="loader-container">
      <motion.div
        style={spinnerStyle}
        className="loader-spinner"
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "linear",
        }}
      />
      {message && <p style={messageStyle}>{message}</p>}
    </div>
  );
};

export default Loader;
